<template>
  <div class="row">
    <div class="col-12 g c">
        <div class="card card-body">
            <div class="g">
                <button class="btn btn-sm btn-success" v-b-modal.add>
                    <i class="fa fa-plus"></i> إضافة اشعار
                </button>
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered table-striped table-sm">
                    <thead>
                        <th>
                            العنوان
                        </th>
                        <th>
                            الرسالة
                        </th>
                        <th>
                            ارسال الى
                        </th>
                        <th>
                            ارسال كل
                        </th>
                        <th>
                            آخر إرسال
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="order in list" :key="order._id">
                            <td>
                                {{ order.title }}
                            </td>
                            <td>
                                <textarea rows="3" class="form-control" readonly v-model="order.message"></textarea>
                            </td>
                            <td>
                                {{ order.phone }}
                            </td>
                            <td>
                                {{ order.days }}
                            </td>
                            <td>
                                {{ order.last_sent }}
                            </td>
                            <td>
                                <button class="btn btn-sm btn-danger" @click="deletex(order._id)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- basic modal -->
    <b-modal
        id="add"
        hide-footer
    >
        <div class="form-group">
        <label for="">العنوان</label>
        <input type="text"
            class="form-control" v-model="title">
        </div>
        <div class="form-group">
        <label for="">الرسالة</label>
        <input type="text"
            class="form-control" v-model="message">
        </div>
        <div class="form-group">
        <label for="">ارسال الى</label>
        <input type="text"
            class="form-control" v-model="phone">
        </div>
        <div class="form-group">
        <label for="">ارسال كل (كام يوم؟)</label>
        <input type="number"
            class="form-control" v-model="days">
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-primary" @click="add()">اضافة</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { BOverlay, BModal, VBModal } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BOverlay,
        BModal,
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            list: [],
            days: 30,
            phone: "",
            message: "",
            title: ""
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/web/notifications/list', {
                jwt: g.user.jwt
            }).then(function(r){
                g.list = r.response
            }).fail(function(){
                alert('Error')
            })
        },
        add(){
            var g = this;
            $.post(api + '/user/web/notifications/add', {
                jwt: g.user.jwt,
                title: g.title,
                message: g.message,
                days: g.days,
                phone: g.phone
            }).then(function(r){
                g.gett()
                alert('تم الاضافة', 100)
            }).fail(function(){
                alert('Error')
            })
        },
        deletex(id){
            var g = this;
            if(confirm("متأكد؟")){
                $.post(api + '/user/web/notifications/delete', {
                    jwt: g.user.jwt,
                    id: id
                }).then(function(r){
                    g.gett()
                }).fail(function(){
                    alert('Error')
                })
            }
        },
    }
}
</script>

<style>

</style>